import { chooseTheme } from "../../../constants/themeColor"
import React from "react";

const SoldOutStrip = () => (
   <img src={process.env.REACT_APP_IMAGES_PATH + "ribbon.webp"} style={{width:"72px", marginTop:"10px"}}/>


    // <svg width="75" height="62" viewBox="0 0 75 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M15 62V0H75L75 62L46 48.5L15 62Z" fill={chooseTheme().primary} />
    //     <path d="M0 9L15 0L19.5 9H0Z" fill={chooseTheme().primary} />
    // </svg>

)

export default SoldOutStrip;